(() => {
  function mount(scope = document) {
    scope.querySelectorAll('[data-buck-menu]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      const nav = document.getElementById(button.getAttribute('aria-controls'));
      if (!nav) return;
      const close = () => { nav.classList.remove('open'); button.setAttribute('aria-expanded', 'false'); button.setAttribute('aria-label', 'Open menu'); };
      button.addEventListener('click', () => {
        const open = !nav.classList.contains('open');
        nav.classList.toggle('open', open); button.setAttribute('aria-expanded', String(open)); button.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      });
      nav.addEventListener('click', e => { if (e.target.closest('a')) close(); });
      button.closest('header').addEventListener('keydown', e => { if (e.key === 'Escape') { close(); button.focus(); } });
      document.addEventListener('click', e => { if (button.isConnected && !button.closest('header').contains(e.target)) close(); });
      nav.querySelectorAll('a').forEach(a => { if (new URL(a.href).pathname.replace(/\/$/, '') === location.pathname.replace(/\/$/, '')) a.setAttribute('aria-current', 'page'); });
    });
    scope.querySelectorAll('[data-design-section]').forEach(root => {
      const form = root.querySelector('[data-design-form]');
      if (!form || !form.querySelector('.step-panel') || form.dataset.ready) return;
      form.dataset.ready = 'true'; form.classList.add('design-js'); form.noValidate = true;
      const panels = [...form.querySelectorAll('.step-panel')];
      const byId = id => root.querySelector(`[data-design-id="${id}"]`) || root.querySelector('#' + id);
      const val = key => form.querySelector(`[data-key="${key}"]:checked`)?.value || '';
      const back = byId('backBtn'), next = byId('nextBtn');
      const min = Math.max(1, Number(root.dataset.minimum) || 1);
      let current = 1;
      const sizes = [...form.querySelectorAll('[data-size]')];
      const total = () => sizes.reduce((sum, input) => sum + (!input.disabled && Number(input.value) > 0 ? Number(input.value) : 0), 0);
      const options = () => [...form.querySelectorAll('[data-key="style"]:checked:not(:disabled)')];
      const tier = qty => qty >= 25 ? root.dataset.tier4 : qty >= 10 ? root.dataset.tier3 : qty >= 5 ? root.dataset.tier2 : root.dataset.tier1;
      const error = (key, visible, text) => {
        const el = form.querySelector(`[data-for="${key}"]`);
        if (el) { el.classList.toggle('show', visible); if (text) el.textContent = text; }
      };
      const showStyles = () => {
        const sport = val('sport');
        const selected = new Set();
        form.querySelectorAll('[data-option-sport]').forEach(label => {
          const active = label.dataset.optionSport === sport || sport === 'both';
          label.hidden = !active;
          const input = label.querySelector('input'); input.disabled = !active;
          if (!active) input.checked = false;
          if (active && input.checked) selected.add(label.dataset.optionSport);
        });
        for (const key of sport === 'both' ? ['basketball', 'soccer'] : [sport]) {
          const first = key && form.querySelector(`[data-option-sport="${key}"] input`);
          if (!selected.has(key) && first) first.checked = true;
        }
        form.querySelectorAll('[data-size-group]').forEach(group => {
          const active = group.dataset.sizeGroup === sport || sport === 'both';
          group.hidden = !active;
          group.querySelectorAll('input').forEach(input => { input.disabled = !active; });
        });
      };
      const update = () => {
        const sport = val('sport'), styles = options(), qty = total();
        const sportLabel = form.querySelector('[data-key="sport"]:checked')?.closest('label')?.querySelector('b')?.textContent?.trim();
        byId('sumSport').textContent = sportLabel || (sport ? sport.charAt(0).toUpperCase() + sport.slice(1) : '—');
        byId('sumStyle').textContent = styles.map(style => style.value).join(' / ') || '—';
        byId('sumColors').textContent = [val('color1'), val('color2')].filter(Boolean).join(' / ') || '—';
        byId('sumQty').textContent = qty;
        byId('qtyTotal').querySelector('b').textContent = qty;
        byId('qtyTotal').classList.toggle('bad', qty > 0 && qty < min);
        form.querySelectorAll('[data-show]').forEach(el => { el.textContent = val(el.dataset.show); });
        const quantityTier = qty >= min ? tier(qty) : '';
        byId('sumEst').textContent = root.dataset.quoteLabel;
        byId('qtyEst').textContent = quantityTier ? `· ${quantityTier}` : '';
        byId('sumUnit').textContent = (quantityTier ? `${root.dataset.tierLabel}: ${quantityTier}. ` : '') + root.dataset.estimateNote;
        form.querySelector('[data-request-total]').value = qty;
        form.querySelector('[data-request-tier]').value = quantityTier;
      };
      const go = (step, focus = true) => {
        current = step;
        panels.forEach((panel, i) => { panel.hidden = i !== step - 1; });
        form.querySelectorAll('.progress li').forEach((li, i) => { li.className = i < step - 1 ? 'done' : i === step - 1 ? 'active' : ''; if (i === step - 1) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current'); });
        back.hidden = step === 1; next.textContent = step === 3 ? root.dataset.submit : root.dataset.next;
        // Only a completed final step may trigger Shopify's native contact/captcha flow.
        next.type = step === 3 ? 'submit' : 'button';
        if (focus) { panels[step - 1].focus({ preventScroll: true }); panels[step - 1].scrollIntoView({ block: 'start', behavior: 'auto' }); }
      };
      const validate = step => {
        if (step === 1) {
          const sport = val('sport');
          const valid = ['basketball', 'soccer', 'both'].includes(sport) && options().length >= (sport === 'both' ? 2 : 1);
          error('sport', !valid, root.dataset.sportError);
          if (!valid) form.querySelector('[data-key="sport"]')?.focus();
          return valid;
        }
        if (step === 2) {
          const active = sizes.filter(input => !input.disabled);
          const hasEachSport = val('sport') !== 'both' || ['basketball', 'soccer'].every(sport => active.filter(input => input.dataset.sizeSport === sport).some(input => Number(input.value) > 0));
          const valid = total() >= min && hasEachSport && active.every(input => input.checkValidity() && Number.isInteger(Number(input.value)));
          error('qty', !valid, root.dataset.quantityError);
          if (!valid) byId('qtyTotal').scrollIntoView({ block: 'center' });
          const artwork = byId('artwork');
          if (valid && artwork && !artwork.checkValidity()) { artwork.reportValidity(); return false; }
          return valid;
        }
        let first = null;
        panels[2].querySelectorAll('input, select, textarea').forEach(input => {
          const valid = input.checkValidity() && (input.type === 'checkbox' || !input.required || !!input.value.trim());
          input.classList.toggle('is-invalid', !valid);
          input.setAttribute('aria-invalid', String(!valid));
          const message = input.closest('.field')?.querySelector('.error');
          if (message) message.classList.toggle('show', !valid);
          if (!valid && !first) first = input;
        });
        error('agree', !byId('agree').checked);
        if (first) { first.focus(); first.reportValidity(); return false; }
        return true;
      };
      const clearResolvedFieldError = input => {
        if (!input.matches('input, select, textarea')) return;
        if (input.checkValidity() && (!input.required || input.type === 'checkbox' || input.value.trim())) {
          input.classList.remove('is-invalid');
          input.setAttribute('aria-invalid', 'false');
          input.closest('.field')?.querySelector('.error')?.classList.remove('show');
          if (input === byId('agree')) error('agree', false);
        }
      };
      form.addEventListener('change', e => {
        if (e.target.dataset.key === 'sport') { showStyles(); error('sport', false); }
        update(); clearResolvedFieldError(e.target);
      });
      form.addEventListener('input', e => { update(); clearResolvedFieldError(e.target); if (total() >= min) error('qty', false); });
      back.addEventListener('click', () => { if (current > 1) go(current - 1); });
      next.addEventListener('click', event => {
        if (current < 3) {
          event.preventDefault();
          if (validate(current)) go(current + 1);
          return;
        }
        if (!validate(3)) { event.preventDefault(); return; }
        for (let step = 1; step <= 2; step++) if (!validate(step)) {
          event.preventDefault(); go(step); return;
        }
      });
      form.addEventListener('keydown', event => {
        if (event.key === 'Enter' && !event.isComposing && event.target.matches('input:not([type="radio"]):not([type="checkbox"]):not([type="date"])')) {
          event.preventDefault(); next.click();
        }
      });
      form.addEventListener('submit', event => {
        if (!validate(current)) { event.preventDefault(); return; }
        if (current < 3) { event.preventDefault(); go(current + 1); return; }
        for (let step = 1; step <= 2; step++) if (!validate(step)) { event.preventDefault(); go(step); return; }
        const lines = [root.dataset.requestSubject || 'Custom jersey request', (root.dataset.estimateLabel || 'Estimated price') + ': ' + byId('sumEst').textContent];
        new FormData(form).forEach((value, key) => { if (key.startsWith('contact[') && key !== 'contact[body]' && value) lines.push(key.slice(8, -1) + ': ' + value); });
        form.querySelector('[data-request-body]').value = lines.join('\n');
        // Continue to Shopify's native contact submission and spam protection.
      });
      const pre = new URLSearchParams(location.search).get('sport');
      if (['basketball', 'soccer', 'both'].includes(pre)) {
        const selected = form.querySelector(`[data-key="sport"][value="${pre}"]`);
        if (selected) selected.checked = true;
      }
      showStyles(); update(); go(1, false);
      root.addEventListener('shopify:block:select', event => {
        const panel = event.target instanceof Element ? event.target.closest('[data-step]') : null;
        if (panel && root.contains(panel)) go(Number(panel.dataset.step), false);
      });
    });
  }
  mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:block:select', event => {
    const details = event.target instanceof Element ? event.target.closest('.buck-section details') : null;
    if (details) details.open = true;
  });
})();
